export default {
  default: () => import("/__w/doxxy-frontend/doxxy-frontend/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/__w/doxxy-frontend/doxxy-frontend/layouts/empty.vue").then(m => m.default || m),
  news: () => import("/__w/doxxy-frontend/doxxy-frontend/layouts/news.vue").then(m => m.default || m)
}